//#region components/empty_state/empty_state_constants.js
var e = {
	sm: "d-empty-state--size-sm",
	md: "d-empty-state--size-md",
	lg: "d-empty-state--size-lg"
}, t = {
	sm: "d-empty-state__content--sm",
	md: "d-empty-state__content--md",
	lg: "d-empty-state__content--lg"
}, n = {
	sm: "d-headline--md",
	md: "d-headline--xl",
	lg: "d-headline--xxl"
}, r = {
	sm: "d-body--sm",
	md: "d-body--sm",
	lg: "d-body--md"
}, i = {
	EMPTY_STATE_SIZE_MODIFIERS: e,
	EMPTY_STATE_CONTENT_SIZE_MODIFIERS: t,
	EMPTY_STATE_HEADLINE_SIZE_MODIFIERS: n,
	EMPTY_STATE_BODY_SIZE_MODIFIERS: r
};
//#endregion
export { r as EMPTY_STATE_BODY_SIZE_MODIFIERS, t as EMPTY_STATE_CONTENT_SIZE_MODIFIERS, n as EMPTY_STATE_HEADLINE_SIZE_MODIFIERS, e as EMPTY_STATE_SIZE_MODIFIERS, i as default };

//# sourceMappingURL=empty-state-constants.js.map